"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[698],{

/***/ 698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Video; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Video-83c15c06.mjs
var Video_83c15c06 = __webpack_require__(2645);
// EXTERNAL MODULE: ../node_modules/next/router.js
var router = __webpack_require__(6677);
// EXTERNAL MODULE: ../node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(7650);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
// EXTERNAL MODULE: ./src/util/magnolia.ts + 1 modules
var magnolia = __webpack_require__(7581);
;// CONCATENATED MODULE: ./src/magnolia/components/Video/Video.tsx





function ensureIframeTitle(embed, title) {
    return embed.replace('title=""', 'title="'.concat(title, '"'));
}
function Video(param) {
    var title = param.title, caption = param.caption, autoplay = param.autoplay, image = param.image, videoType = param.videoType, video = param.video, youtubeVideoUrl = param.youtubeVideoUrl, icareus = param.icareus;
    var isPreview = (0,router.useRouter)().isPreview;
    var derivedVideoType = "";
    var videoSrc = "";
    var imgSrc = "";
    var mimeType = "";
    var embedCode = "";
    if (videoType === "asset") {
        var ref;
        derivedVideoType = "asset";
        videoSrc = (0,magnolia/* getAssetPath */.K3)(video, isPreview);
        var ref1;
        mimeType = (ref1 = (ref = video.metadata) === null || ref === void 0 ? void 0 : ref.mimeType) !== null && ref1 !== void 0 ? ref1 : "";
    }
    if (image) {
        imgSrc = (0,magnolia/* getAssetPath */.K3)(image, isPreview);
    }
    if (videoType === "youtube") {
        if (!youtubeVideoUrl) {
            return null;
        }
        derivedVideoType = "embed";
        embedCode = '\n      <iframe\n        src="'.concat(youtubeVideoUrl.replace("watch?v=", "embed/"), '"\n        title="').concat(title || "Youtube video", '"\n        allowfullscreen\n        enablejsapi\n      ></iframe>\n    ');
    }
    var sanitizedData = function() {
        return browser_default().sanitize(icareus, {
            ADD_TAGS: [
                "iframe"
            ],
            ADD_ATTR: [
                "allow",
                "autoplay",
                "allowfullscreen",
                "frameborder",
                "scrolling", 
            ]
        });
    };
    if (videoType === "icareus") {
        derivedVideoType = "icareusIframe";
        embedCode = sanitizedData();
        embedCode = ensureIframeTitle(embedCode || "", title || "Embedded video");
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Video_83c15c06.V, {
        title: title,
        caption: caption,
        image: imgSrc,
        video: {
            src: videoSrc,
            mimeType: mimeType
        },
        autoplay: autoplay,
        embed: embedCode,
        videoType: derivedVideoType,
        styling: Video_83c15c06.a.ARTICLE
    });
}

;// CONCATENATED MODULE: ./src/magnolia/components/Video/index.ts
/* istanbul ignore file */ 


/***/ }),

/***/ 2645:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ h; },
/* harmony export */   "a": function() { return /* binding */ C; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(403);
/* harmony import */ var _useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7720);



const A = "video", f = "video__hero", g = "video__article", k = "desktop", P = "video__caption", d = {
  video: A,
  videoHero: f,
  videoArticle: g,
  desktop: k,
  videoCaption: P
};
var C = /* @__PURE__ */ ((t) => (t.ARTICLE = "videoArticle", t.HERO = "videoHero", t))(C || {});
function h({
  title: t,
  caption: s,
  styling: i,
  autoplay: l,
  embed: o,
  image: u = "",
  videoType: c,
  video: r,
  viewport: m
}) {
  const E = Array.isArray(r) ? r.find((y) => m && y.device?.includes(m)) : r, a = (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(d.video, i && d[i]), p = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, c === "icareusIframe" && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      className: a,
      dangerouslySetInnerHTML: { __html: o }
    }
  ), c === "embed" && (o?.includes("iframe") ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      className: a,
      dangerouslySetInnerHTML: { __html: o }
    }
  ) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "video",
    {
      "data-testid": "videoplayer-embed",
      itemProp: "video",
      title: t,
      className: a,
      src: o,
      playsInline: !0,
      controls: !0
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("track", { kind: "captions" })
  )), c === "asset" && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, l ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "video",
    {
      "data-testid": "videoplayer-asset",
      itemProp: "video",
      title: t,
      className: a,
      src: E?.src,
      autoPlay: l,
      loop: !0,
      muted: !0,
      playsInline: !0
    }
  ) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "video",
    {
      "data-testid": "videoplayer-asset-control",
      itemProp: "video",
      title: t,
      className: a,
      controls: !0,
      poster: u,
      playsInline: !0
    },
    !Array.isArray(r) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", { src: r.src, type: r.mimeType }),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("track", { kind: "captions" })
  )));
  return i === "videoArticle" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_2__.B,
    {
      topPadding: _useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_2__.B.Padding.SMALL,
      bottomPadding: _useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_2__.B.Padding.LARGE,
      "data-testid": "article-video"
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_2__.B.Content, { "data-testid": "article-video-content" }, p, s && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", { className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsCaption, d.videoCaption) }, s))
  )) : p;
}

//# sourceMappingURL=Video-83c15c06.mjs.map


/***/ })

}]);